import { Add, Check } from "@mui/icons-material";
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React, { useState } from "react";
import companyEmployeeService from "../../services/companyEmployeeService";
import { pink } from "../../shared/colours";
import SubmitModal from "../Admin/SubmitModal";

const CyberTrainingCourseTable = (props) => {
	
	let [ showSubmitModal, setShowSubmitModal ] = useState(false);
	let [ sentSuccess, setSentSuccess ] = useState(false);
	
	const handleSubscribeClick = async (stats) => {
		setSentSuccess(false);
		setShowSubmitModal(true);
		
		await companyEmployeeService.subscribeCompanyToCourse(true, stats.id);
		
		setSentSuccess(true);
		setTimeout(() => {
			setShowSubmitModal(false);
		}, 1500);
	};
	
	const handleUnsubscribeClick = async (stats) => {
		setSentSuccess(false);
		setShowSubmitModal(true);
		
		await companyEmployeeService.subscribeCompanyToCourse(false, stats.id);
		
		setSentSuccess(true);
		setTimeout(() => {
			setShowSubmitModal(false);
		}, 1500);
	};
	
	const handleEnrollClick = async (stats) => {
		setSentSuccess(false);
		setShowSubmitModal(true);
		
		await companyEmployeeService.enrollAllOnCourse(stats.id);
		
		setSentSuccess(true);
		setTimeout(() => {
			setShowSubmitModal(false);
		}, 1500);
	};
	
	const handleCourseClick = (course) => {
		props.onCourseClick(course);
	};
	
	const handleSubmitModalClose = () => {
		setSentSuccess(false);
		setShowSubmitModal(false);
	};
	
	return (
		<Box sx={{width: "100%", margin: "auto"}}>
			<TableContainer component={Paper} sx={{ width: "100%" }}>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell sx={{ textAlign: "left" }}>Name</TableCell>
							<TableCell sx={{ textAlign: "center" }}>Total Not Started</TableCell>
							<TableCell sx={{ textAlign: "center" }}>Total Started</TableCell>
							<TableCell sx={{ textAlign: "center" }}>Total Completed</TableCell>
							<TableCell sx={{ textAlign: "center" }}>Average Retries</TableCell>
							<TableCell sx={{ textAlign: "center" }}>Average Grade</TableCell>
							{(props.showAll)?
								<TableCell sx={{ textAlign: "center" }}>Subscribed</TableCell>
							:
								<TableCell sx={{ textAlign: "center" }}>Enroll Employees</TableCell>
							}
						</TableRow>
					</TableHead>
					<TableBody>
						{props.courseStats? props.courseStats.map((stats) => (
							(props.showAll || stats.company_course_id)?
								<TableRow
									key={`course_${stats.id}`}
									sx={{ ":hover": { cursor: "pointer" } }}
									onClick={() => { handleCourseClick(stats); }}
								>
									<TableCell sx={{ textAlign: "left" }}>
										{`${stats.label}`}
									</TableCell>
									<TableCell sx={{ textAlign: "center" }}>
										{`${stats.employeesNotStarted}`}
									</TableCell>
									<TableCell sx={{ textAlign: "center" }}>
										{`${stats.employeesStarted}`}
									</TableCell>
									<TableCell sx={{ textAlign: "center" }}>
										{`${stats.employeesCompleted}`}
									</TableCell>
									<TableCell sx={{ textAlign: "center" }}>
										{`${stats.averageRetries.toFixed(2)}`}
									</TableCell>
									<TableCell sx={{ textAlign: "center" }}>
										{`${stats.averageGrade}`}
									</TableCell>
									{(props.showAll)?
										<TableCell sx={{ textAlign: "center" }}>
											{(stats.company_course_id)?
												<Button onClick={() => { handleUnsubscribeClick(stats); }}>
													<Check/>
												</Button>
											:
												<Button onClick={() => { handleSubscribeClick(stats); }}>
													<Add sx={{color: pink}}/>
												</Button>
											}
										</TableCell>
									:
										<TableCell sx={{ textAlign: "center" }}>
											<Button onClick={() => { handleEnrollClick(stats); }}>
												<Add sx={{color: pink}}/>
											</Button>
										</TableCell>
									}
								</TableRow>
							:<React.Fragment key={`course_${stats.id}`}/>
						)):<React.Fragment/>}
					</TableBody>
				</Table>
			</TableContainer>
			<SubmitModal
				open={showSubmitModal}
				sentSuccess={sentSuccess}
				onClose={handleSubmitModalClose}
			/>
		</Box>
	);

}

export default CyberTrainingCourseTable;